import { useFormikContext } from "formik";
import React, { useMemo } from "react";
import { MaskedFormInput } from "@/core/components/masked-form-input";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { getValidDollarAmountMask } from "@/core/masks/currency-masks";
import {
  SPIFF_RULE_INPUT_LABELS,
  SpiffRuleFormValues,
} from "./spiff-rule-form-values";

const SpiffRuleDollarInputBase = ({
  name,
  ...props
}: {
  name: keyof typeof SPIFF_RULE_INPUT_LABELS;
} & Omit<
  React.ComponentProps<typeof MaskedFormInput>,
  "value" | "onChange" | "maskOptions"
>) => {
  const { values, setFieldValue } = useFormikContext<SpiffRuleFormValues>();

  const maskOptions = useMemo(() => getValidDollarAmountMask(true), []);

  return (
    <div className="w-[11rem]">
      <MaskedFormInput
        name={name}
        value={values[name]}
        onChange={(value) => setFieldValue(name, value)}
        maskOptions={maskOptions}
        label={SPIFF_RULE_INPUT_LABELS[name]}
        fullWidth
        persistentLabel
        {...props}
      />
    </div>
  );
};

export const SpiffRuleDollarInput = ({
  disabledTooltip,
  ...props
}: {
  name: keyof typeof SPIFF_RULE_INPUT_LABELS;
  disabledTooltip?: React.ReactNode | string;
} & Omit<
  React.ComponentProps<typeof MaskedFormInput>,
  "value" | "onChange" | "maskOptions"
>) => {
  if (disabledTooltip) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <SpiffRuleDollarInputBase {...props} />
          </div>
        </TooltipTrigger>
        <TooltipContent>{disabledTooltip}</TooltipContent>
      </Tooltip>
    );
  }

  return <SpiffRuleDollarInputBase {...props} />;
};
